import React from 'react';
import { Globe } from 'lucide-react';
import Como from '../../assets/spice grain commodities new gem.webp';

const CommodityHome = ({ company }) => {
  const getHeroIcon = (companyId, size = 120) => {
    // Matches 'Commodities' exactly as per your COMPANIES data
    if (companyId === 'Commodities' || companyId === 'commodities' || companyId === 'global') {
      return (
        <img
          src={Como}
          alt="Commodities Hero"
          className={`w-[${size / 8}] h-[${size / 8}] max-w-[${size}px] max-h-[${size}px] drop-shadow-2xl object-contain`}
        />
      );
    }

    return <Globe size={size} className="text-blue-600 drop-shadow-lg" />;
  };

  return (
    <div className="animate-in fade-in duration-700">
      {/* Light Blue & Sky Gradient Background */}
      <section className="bg-gradient-to-br from-blue-50 via-sky-50 to-indigo-100 py-24 px-6 relative overflow-hidden">
        {/* Soft Radial Glow */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(56,189,248,0.2),transparent)]"></div>

        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10">
          <div className="space-y-8">
            {/* Heading with Blue/Indigo Gradients */}
            <h2 className="text-6xl font-black leading-tight mb-6 bg-gradient-to-r from-slate-900 via-blue-900 to-indigo-800 bg-clip-text text-transparent drop-shadow-2xl">
              Global <span className="text-transparent bg-gradient-to-r from-sky-500 to-blue-600 bg-clip-text drop-shadow-2xl">Trade</span>, Trusted Excellence.
            </h2>

            <p className="text-xl text-slate-700/90 mb-10 leading-relaxed max-w-lg bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-2xl border border-blue-100/50">
              {company?.description || "Bridging international markets with premium quality commodities."}
              Ensuring seamless supply chains from origin to global destinations.
            </p>

            <div className="flex flex-col sm:flex-row gap-6">
              {/* Primary Button: Solid Blue Gradient */}
              <button className="px-12 py-7 bg-gradient-to-r from-blue-600 to-sky-500 text-white rounded-3xl font-black text-xl hover:from-blue-700 hover:to-sky-600 hover:shadow-2xl hover:shadow-blue-500/40 transition-all duration-500 shadow-xl hover:scale-105 group">
                <span className="block group-hover:-translate-x-2 transition-transform">Market Portfolio</span>
              </button>

              {/* Secondary Button: Outlined Blue */}
              <button className="px-12 py-7 border-4 border-sky-400 text-blue-700 rounded-3xl font-black text-xl hover:bg-white hover:shadow-2xl hover:shadow-sky-200/50 hover:scale-105 transition-all duration-500 bg-white/70 backdrop-blur-sm flex items-center justify-center group">
                <span className="group-hover:-translate-x-1 transition-transform">Trade Inquiries</span>
              </button>
            </div>
          </div>

          <div className="hidden md:flex justify-center relative">
            {/* Glassmorphism Container with Blue Border */}
            <div className="w-96 h-96 bg-white/90 backdrop-blur-2xl rounded-[3rem] shadow-2xl flex items-center justify-center border-8 border-blue-50 relative group hover:shadow-sky-300/40 transition-all duration-1000 hover:scale-110 hover:rotate-1">


              {/* Internal Glows */}
              <div className="absolute inset-0 bg-gradient-to-br from-sky-200/30 to-indigo-200/30 rounded-[3rem] opacity-0 group-hover:opacity-100 transition-all duration-700 blur-xl"></div>
              <div className="absolute inset-4 bg-gradient-to-r from-slate-50 to-blue-50 rounded-[2.8rem] shadow-inner"></div>

              <div className="relative z-20 transition-transform duration-500 group-hover:scale-110">
                {getHeroIcon(company?.id, 140)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CommodityHome;